'use client';
import { useRef, useState } from 'react';
import style from '../style.module.scss';
import Product from './products';
import ProductSwiper from './productSwiper';
import TextSwiper from './textSwiper';
import ArrowRight from '@/assets/icons/ArrowRight.svg';
import SafeLink from '@/components/SafeLink';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import { useRouter } from 'next/navigation';

interface FlashSalesClientProps {
  moduleData: any;
  pageConfig: any;
  channelTextList: Array<{ channelText: string; channelType: number }>;
  title: string;
  currentTime?: number;
}

export default function FlashSalesClient({
  moduleData,
  pageConfig,
  channelTextList,
  title,
  currentTime = Date.now(),
}: FlashSalesClientProps) {
  const router = useRouter();
  // 创建 refs 来控制两个轮播组件
  const textSwiperRef = useRef<any>(null);
  const productSwiperRef = useRef<any>(null);

  // 获取当前轮播项的 channelType
  const getCurrentChannelType = () => {
    return textSwiperRef.current?.getCurrentChannelType() || 0;
  };

  // 统一跳转至秒杀
  const handleClick = (e: any) => {
    // const channelType = getCurrentChannelType();
    router.push(`/offer?channelType=0`);
    spmTrackingUtils.spmClick({
      spm: 'a0145.b002218.c00002479.more',
      page_id: 'Home_Main',
      event_id: 'Home_Pro_FlashSales_More',
      target: e.target as HTMLElement,
    });
  };
  return (
    <div className={style['uk-h5-flash-sales']}>
      <div className={style.bar}>
        <div
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          data-exp={JSON.stringify({
            spm: 'a0145.b002218.c00002479.more',
            page_id: 'Home_Main',
            event_id: 'Home_Pro_FlashSales_More_Expo',
          })}
        >
          <div className={style.barContainer}>
            <p className={style.title}>{title}</p>
            <TextSwiper ref={textSwiperRef} channelTextList={channelTextList} />
          </div>
          <div className={style.rightIcon}>
            <ArrowRight className={style.headerIcon} />
          </div>

          {/* 右上角倒计时暂时不用 */}
          {/* <Timer pageConfig={pageConfig} currentMills={currentMills} moduleData={moduleData} /> */}
        </div>
      </div>
      <div className={style.products}>
        <ProductSwiper
          ref={productSwiperRef}
          products={pageConfig.swiperProducts || []}
          currentTime={currentTime}
          happyHourPeriod={moduleData.externalData?.data?.lightningDealsText?.happyHourPeriod}
        />
        {pageConfig.products?.map((product: any, index: number) => (
          <Product product={product} index={index} key={`${product.skuId}-${index}`} />
        ))}
      </div>
    </div>
  );
}
